import React from 'react'
import './index.css'
import Flex from 'components/Flex'
import logUtil from 'utils/log'
import useSelector from 'hooks/use-selector'
import { SQUAD_FILTER_TYPE } from 'modules/squad/redux/constants'
import loadMemberProductsByFilterTypeSquadAction from 'modules/squad/redux/actions/load-member-products-by-filter-type'
import useDispatch from 'hooks/use-dispatch'
import getMemberProductsByIdAndFilterTypeSquadSelector from 'modules/squad/redux/selectors/get-member-products-by-id-and-filter-type'
import H3 from 'components/H3'
import FlexColumn from 'components/FlexColumn'
import pluralizeStringUtil from 'utils/string/plurialize'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import Button from 'components/Button'
import noopFunctionUtil from 'utils/functions/noop'
import Section from 'components/Section'
import areProductsLoadedByMemberIdSquadSelector from 'modules/squad/redux/selectors/are-products-loaded-by-member-id'
import ProductVariantCarouselInfo from 'pages/Squad/containers/ProductVariantCarouselInfo'
import usePrevious from 'hooks/use-previous'

const ANALYTICS_EVENT = {
  VIEW_SQUAD_FRIEND_DISLIKED_PRODUCTS: 'VIEW_SQUAD_FRIEND_DISLIKED_PRODUCTS',
  SEE_MORE_SQUAD_FRIEND_DISLIKED_PRODUCTS: 'SEE_MORE_SQUAD_FRIEND_DISLIKED_PRODUCTS',
  VIEW_SQUAD_DISLIKED_PRODUCTS: 'VIEW_SQUAD_DISLIKED_PRODUCTS',
  SHOW_SQUAD_DISLIKED_PRODUCTS: 'SHOW_SQUAD_DISLIKED_PRODUCTS',
  SEE_MORE_DISLIKED_PRODUCTS: 'SEE_MORE_DISLIKED_PRODUCTS'
}
const PAGE_SIZE = 8
const SKIP_COUNT = 0
const SEE_MORE = 'See more'
const LOADING = 'Loading...'

export default function SquadPageDislikedSamples (props) {
  const dispatch = useDispatch()
  const { id, name, isCurrentCustomer } = props
  const isLoaded = useSelector(
    areProductsLoadedByMemberIdSquadSelector(id, SQUAD_FILTER_TYPE.not_like)
  )
  /**
   * @type {import('modules/squad/types').GetSquadProductsResp}
   */
  const sampleData = useSelector(getMemberProductsByIdAndFilterTypeSquadSelector(id, SQUAD_FILTER_TYPE.not_like))
  const products = sampleData?.products
  const productsCount = products?.length
  const totalProductsCount = sampleData?.total_product_count
  const hasMoreProducts = productsCount < totalProductsCount
  const debugProps = {
    isLoaded,
    sampleData,
    totalProductsCount,
    hasMoreProducts,
    props
  }
  const prevProductsCount = usePrevious(productsCount)
  React.useEffect(() => {
    if (!prevProductsCount && productsCount) {
      logEventAnalyticsUtil(ANALYTICS_EVENT.SHOW_SQUAD_DISLIKED_PRODUCTS)
    }
  }, [prevProductsCount, productsCount])

  const loadProducts = (params) => {
    dispatch(
      loadMemberProductsByFilterTypeSquadAction({
        memberId: id,
        filterType: SQUAD_FILTER_TYPE.not_like,
        pageSize: PAGE_SIZE,
        skipCount: SKIP_COUNT,
        ...params
      })
    )
  }

  React.useEffect(() => {
    if (id && !isLoaded) {
      loadProducts()
    }
  }, [id])

  const handleClickItem = () => {
    logEventAnalyticsUtil(
      isCurrentCustomer
        ? ANALYTICS_EVENT.VIEW_SQUAD_DISLIKED_PRODUCTS
        : ANALYTICS_EVENT.VIEW_SQUAD_FRIEND_DISLIKED_PRODUCTS
    )
  }

  const handleClickSeeMore = () => {
    logEventAnalyticsUtil(
      isCurrentCustomer
        ? ANALYTICS_EVENT.SEE_MORE_DISLIKED_PRODUCTS
        : ANALYTICS_EVENT.SEE_MORE_SQUAD_FRIEND_DISLIKED_PRODUCTS
    )
    loadProducts({
      skipCount: productsCount
    })
  }

  logUtil('SquadPageDislikedSamples').debug('debugProps=', debugProps)
  if (!isLoaded && !productsCount) {
    logUtil('SquadPageDislikedSamples').debug('[noop] not loaded')
    return <></>
  }

  if (!productsCount) {
    logUtil('SquadPageDislikedSamples').debug('[noop] no sampleData')
    return <></>
  }

  return (
    <Section
      className='squad-disliked-samples'
    >
      <FlexColumn
        className='squad-disliked-samples-content'
      >

        <Flex className='squad-disliked-samples-title'>
          <H3>{isCurrentCustomer ? 'You’ve' : `${name} has`} disliked {totalProductsCount} {pluralizeStringUtil('sample', totalProductsCount)}</H3>
        </Flex>
        <Flex className='squad-disliked-samples-list'>
          {
            sampleData.products.map((sampleProduct, index) => {
              const key = `${sampleProduct.product_id}-${sampleProduct.variant_id}-${index}`
              return (
                <Flex
                  key={key}
                  className='squad-disliked-sample'
                >
                  <ProductVariantCarouselInfo
                    productVariant={sampleProduct}
                    onClick={handleClickItem}
                  />
                </Flex>
              )
            })
          }
        </Flex>
        {!!hasMoreProducts && (
          <Button
            className='squad-disliked-samples-see-more'
            onClick={isLoaded ? handleClickSeeMore : noopFunctionUtil}
          >
            {isLoaded ? SEE_MORE : LOADING}
          </Button>
        )}
      </FlexColumn>
    </Section>
  )
}
